<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-text-editor-warning-modal']"
   :additionalZIndex="3"
   :isOpen="isModalOpen"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @beforeEnterContent="handleBeforeEnterContent"
   @afterEnterContent="handleAfterEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
    <div class="pa-wide-modal-box-wrapper pa-text-editor-warning">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="text-editor-warning-content">
          <p class="pa-title">御注意事項</p>
          <div class="text-set">
            <p>塔経市帝では異世界の坩堝としての異界特異点都市機能を潤滑に継続提供する為、異世界相互理解の概念に基づいた都市の自治を行っています。</p>
            <p>電子異界渡航者の皆様にも上記の概念に基づいた塔経市帝内の法則が適応されるものと致します。</p>
          </div>
          <hr class="pa-separator" />
          <div class="list-set">
            <p class="caption">以下の態度及び御投稿内容は御遠慮ください。</p>
            <ul class="pa-list">
              <li>自所属及び他世界に対する否定的な意見並びに攻撃的な発言等</li>
              <li>己と異なる出自や考え方を持つ他者に対して相互理解が欠落した発言や態度</li>
              <li>自所属及び他世界の政に関連する投稿</li>
              <li>世の発展を阻害及び持続的な社会の発展を否定する発言等</li>
              <li>他者の創作活動を否定する様な発言等</li>
              <li>異界接続の基盤となる魔術及び超常的な現象の否定</li>
              <li>万物の根源である想像力を否定する発言</li>
              <li>その他塔経市帝の管轄機関により不適切と判断された投稿や発言等</li>
            </ul>
          </div>
          <hr class="pa-separator pa-separator-bottom" />
          <form class="pa-form">
            <input
             id="isSetWarningSkip"
             type="checkbox"
             name="isSetWarningSkip"
             class="switch is-small"
             v-model="isSetWarningSkip"
             :disabled="isDisabledSkipSwitch"
            />
            <label for="isSetWarningSkip">一定期間この表示をスキップする</label>
            <p class="mini">（1週間表示がスキップされます。）</p>
          </form>
          <button
           class="button pa-button"
           :class="submitButtonClass"
           :disabled="submitButtonDisabled"
           @click.prevent="handleClickSubmitButton"
          >了承して投稿する</button>
          <button
           class="button pa-button-line"
           @click.prevent="handleClickCancelButton"
          >投稿をキャンセルする</button>
        </div>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'

import TextSendWarningMixins from '@/mixins/TextSendWarningMixins.js'

export default {
  components : {
    PaOverlayModal
  },

  mixins : [
    TextSendWarningMixins
  ],

  data(){
    return {
      isSetWarningSkip      : true,
      isDisabledSkipSwitch  : false,
      
      isFreezModal          : false,

      submitButtonClass     : {
        'is-loading'  : false
      },

      submitButtonDisabled  : false,
    };
  },

  computed : {
    isModalOpen(){
      return this.$store.state.textEditorWarningModal.isOpenModal;
    },

    isSubmitLoading(){
      return this.$store.state.textEditorWarningModal.isSubmitLoading;
    },

    isDisabledSubmitButton(){
      return this.$store.state.textEditorWarningModal.isDisabledSubmitButton;
    },

    handleSubmitFunction(){
      return this.$store.state.textEditorWarningModal.handleSubmitFunction;
    },

    handleCancelFunction(){
      return this.$store.state.textEditorWarningModal.handleCancelFunction;
    }
  },

  methods : {
    handleAfterEnterContent(){
      const actualHeight = window.innerHeight - ((window.innerHeight * .1) * 2);

      const boxHeight = this.$refs.wideModalBox.offsetHeight;

      if(boxHeight > actualHeight){
        this.$refs.wideModalBox.style.height = actualHeight + 'px';
      }
    },

    handleSubmit(){
      if(typeof this.handleSubmitFunction === 'function'){
        this.handleSubmitFunction();
      }
    },

    handleCancel(){
      if(typeof this.handleCancelFunction === 'function'){
        this.handleCancelFunction();
      }
    },

    handleCloseOverlay(){
      this.handleCancel();
    },

    handleClickSubmitButton(){
      this.submitButtonDisabled = true;
      this.submitButtonClass['is-loading'] = true;

      this.setSkipWarningModalCookie(this.isSetWarningSkip);

      this.handleSubmit();
    },

    handleBeforeEnterContent(){
      this.submitButtonDisabled = false;
      this.submitButtonClass['is-loading'] = false;
    },

    handleClickCancelButton(){
      this.handleCancel();
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/bulma.sass";

.pa-text-editor-warning{
  .pa-wide-modal-box{
    overflow-y: scroll;
  }
  
  .text-editor-warning-content{
    p.pa-title{
      padding-top:4px;
      text-align: center;
      font-size:22px;
      line-height: 34px;
      color: #513F28;

      @include until(375px) {
        font-size:18px;
        line-height: 28px;
      }
    }

    div.text-set{
      margin:0 6px;
      
      p{
        font-size: 14px;
        line-height: 1.4;
        color:#513F28;

        @include until(375px) {
          font-size: 12px;
          line-height: 1.3;
        }
      }
    }

    hr.pa-separator{
      margin:12px auto 10px;
      padding:0;
      background-color: #BFA687;
      height:3px;
      width:92%;

      @include until(375px) {
        margin:8px auto 5px;
      }

      &-bottom{
        margin:10px auto 8px;
        height:2px;

        @include until(375px) {
          margin:0px auto 6px;
        }
      }
    }

    div.list-set{
      margin:0 6px;

      p.caption{
        text-align: center;
        color:#513F28;
        margin-bottom:10px;
        font-size:.9rem;
        line-height: 1;

        @include until(375px) {
          font-size:.8rem;
        }
      }

      ul.pa-list{
        color:#513F28;
        font-size: 12px;
        margin-right:10px;
        
        li{
          margin-bottom:4px;
          padding:0;
          padding-left:.5rem;
          list-style: inside;
          list-style-type: disc;
          font-size:.75rem;
          line-height: 1.4;

          @include until(375px) {
            font-size: 11px;
            line-height: 1.2;
          }

          &::before{
            margin-right:0;
            margin:0;
            padding:0;
          }

          &::marker{
            margin:0;
            margin-right:0 !important;
          }
        }
      }
    }

    form.pa-form{
      margin-bottom:8px;
      text-align: center;
      color:#513F28;

      @include until(375px) {
        margin-bottom:6px;
      }

      .switch[type=checkbox].is-small:checked + label::before, .switch[type=checkbox].is-small:checked + label:before{
        background-color: #998060;
      }

      .switch[type=checkbox].is-small + label::after, .switch[type=checkbox].is-small + label:after{
        background-color: #8E7656;
      }

      .switch[type=checkbox].is-small:checked + label::after, .switch[type=checkbox].is-small:checked + label:after{
        background-color: #B9751F;
      }

      .switch[type=checkbox].is-small + label::before, .switch[type=checkbox].is-small + label:before{
        background-color: #A88E6D;
      }

      .switch[type=checkbox].is-small + label{
        margin-top:0;
        padding-top:0;
        font-size:.8rem;

        @include until(375px) {
          font-size:.7rem;
        }
      }

      p.mini{
        text-align: center;
        font-size: .6rem;
      }
    }

    button.pa-button{
      display: block;
      width:60%;
      margin:0 auto;
      border:2px solid #A4734B;
      background-color:#C49065;
      border-radius: 20px;
      color:#5E3717;

      @include until(375px) {
        padding:3px;
        font-size:14px;
        height: inherit;
      }

      &.is-loading::after{
        border: 1.3px solid #5E3717;
        border-right-color: transparent;
        border-top-color: transparent;
      }
    }

    button.pa-button-line{
      margin:8px 0 4px 4px;
      padding:0;
      border:none;
      background-color: inherit;
      font-size:.7rem;
      height: inherit;
      line-height: 1.3;
      border-radius:inherit;
      border-bottom:1px solid #8C7B67;
      color:#8C7B67;

      @include until(375px) {
        margin:14px 0 4px 4px;
        font-size:.6rem;
      }
    }
  }
}
</style>